import { OutletListItem, OutletState } from '@ancon/wildcat-types'
import { Translate } from 'next-translate'
import isOutletAcceptingPreOrdersWhenClosed from '@ancon/wildcat-utils/outlet/isOutletAcceptingPreOrdersWhenClosed'

import isOutletAcceptingOnlyPreOrdersWhenOpen from './isOutletAcceptingOnlyPreOrdersWhenOpen'

function getOutletStatusLabel(outlet: OutletListItem | null, t: Translate) {
  const isOutletOpen = outlet?.state === OutletState.Opened

  const isAcceptingPreOrdersWhenClosed =
    isOutletAcceptingPreOrdersWhenClosed(outlet)

  const isAcceptingOnlyPreOrdersWhenOpen =
    isOutletAcceptingOnlyPreOrdersWhenOpen(outlet)

  if (isAcceptingOnlyPreOrdersWhenOpen) {
    return `${t('common:outlet.open')} • ${t('common:outlet.preOrdersOnly')}`
  }

  if (isOutletOpen) {
    return t('common:outlet.open')
  }

  if (isAcceptingPreOrdersWhenClosed) {
    return t('common:outlet.acceptingPreOrders')
  }

  return t('common:outlet.closed')
}

export default getOutletStatusLabel
